import { useEffect, useState } from "react";
import { _Entailment, _single } from "../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { BasicPage } from "../../../theme/Component/BasicPage";
import { BasicTable, MASK_DECIMAL } from "../../../theme/Component/BasicTable";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { Modal } from "../../../theme/Component/Modal";
import { Singleton } from '../../../../core/services/Singleton';
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import { toast } from "react-toastify";
import usePaginator from "../../../theme/Component/usePaginator";
import { _AddCommercialCampaign, _AirLine, _Airport, _CommercialCampaign, _CustomerAddress, _ProvisionByData, _ProvisionCatalogData, _Reprovision } from "../../../../core/services/dataBean/EntityCatalogVdos";
import { BasicButton } from "../../../theme/Component/BasicButton";
import { AccountEditor } from "../../../editor/AccountEditor";
import { BasicSwitch } from "../../../theme/Component/BasicSwitch";
import { EmployeeBonusEditor } from "../EmployeeBonus/Editors/EmployeeBonus.Editor";
import { AccountantYear } from "../../GestionTH/EmployeeContract/ProductionPlan/AccountantYear";
import { MonthEditorbyconst } from "../../../RemoteAbstractAction/editors/MonthEditorbyconst";
import { FileService } from "../../../../core/services/FileService";
import { VisorAnyDocument } from "../../../documents/VisorAnyDocument";

interface Props {
    idProvisionData: number;
}
export const ProvisionCatalogByData = ({ idProvisionData }: Props) => {

    const data = useDataBean(_ProvisionByData);
    const reprovision = useDataBean(_Reprovision);
    const prvdata = useDataBean(_ProvisionCatalogData);
    const [form, setForm] = useState<any>({
        Year: _single.getCurrenYear(),
        Month: _single.getCurrentMonth()
    });
    const fileService = new FileService();
    const [formato, setFormato] = useState<any>(null)
    const [type, settype] = useState<any>([]);
    const paginador = usePaginator();
    const [regexStr, setregexStr] = useState<any>(null)
    const single = Singleton.getInstance();
    const [lista, setLista] = useState<any>([]);
    const [Account, setAccount] = useState<number>(null)
    const [EmployeeBonus, setEmployeeBonus] = useState<number>(null)
    const [modalviewdoc, setModalviewdoc] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-xl' });
    const [modalcalculate, setModalcalculate] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: "Eliminar", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    useEffect(() => {
        getLista();
    }, [idProvisionData, paginador.page])

    const getLista = () => {

        data.instance.getProvisionCatalog(idProvisionData, Account, EmployeeBonus, paginador.page, 15).then(
            (resp: any) => {
                if (resp) {
                    paginador.setPages(resp.NumberOfPages);
                    paginador.setRecords(resp.NumberOfPages * (15));
                    paginador.setRegiPerPage(15)
                    // setLista(resp.List)
                    let x = resp.List;
                    x.forEach((user) => {
                        user.DataBeanProperties.Bonus = (user.DataBeanProperties.EmploymentBonusCode ?? "") + "-" + (user.DataBeanProperties.EmploymentBonusName ?? "");
                    });
                    setLista(x)
                }
            }
        )

    }
    const create = () => {
        data.setBean({

        });
        setModal({ ...modal, "view": true });
    }
    const deleteItem = () => {
        // data.instance.deleteAirLine(data.bean.IDAirLine).then(
        //     (resp: any) => {
        //         getLista();
        //         setModalC({ ...modalC, "view": false });
        //     }
        // )

    }
    const editaItem = () => {
        //console.log(entailment.bean);
        data.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }
    const ver = () => {

        setModal({ ...modal, "view": true });
    }
    const getFileType = (mediaName: string) => {
        let fileType = mediaName.split('.').pop()?.toLowerCase();
        return fileType;
    }
    // const createProvisions = () => {

    //     prvdata.instance.createProvisions(form.Year, form.Month, _single.getAccountID(), false, false).then(
    //         (resp: any) => {
    //             if (resp) {
    //                 let data = resp[0].DataBeanProperties;
    //                 console.log(resp)
    //                 setModal({ ...modal, "view": false });
    //                 const url = fileService.getUrlFile(data.MediaContext, data.Media);
    //                 const type = getFileType(data.Media);
    //                 settype(type)
    //                 setFormato(url)
    //                 setModalviewdoc({ ...modalviewdoc, "view": true });
    //             }
    //         }
    //     )

    // }
    const head = [
        { title: 'ID', property: 'IDProvision', visible: true },
        { title: 'Beneficio', property: 'Bonus', visible: true },
        { title: 'Cuenta Provisión', property: 'ProvAccountantIDStrName', visible: true },
        { title: 'Cuenta de Gasto', property: 'ExpAccountantIDStrName', visible: true },
        { title: 'Rubro Presupuestal', property: 'BudgetName', visible: true },
        { title: 'Valor Salario', property: 'SalaryValue', visible: true, mask: MASK_DECIMAL },
        { title: 'Beneficio Proyectado al 100%', property: 'ProjectedBenefit', visible: true, mask: MASK_DECIMAL },
        { title: 'Valor Beneficio a Pagar', property: 'TotalProvisionValue', visible: true, mask: MASK_DECIMAL },
        { title: 'Provisión Mensual', property: 'ProvisionAtMonth', visible: true, mask: MASK_DECIMAL },
        { title: 'Provisión Vigencia a la Fecha', property: 'ActualProvisionValue', visible: true, mask: MASK_DECIMAL },
        { title: 'Vigencias Anteriores', property: 'PreviousPeriodProvisionValue', visible: true, mask: MASK_DECIMAL },
        { title: 'Saldo Libro Contable', property: 'AccountantBookValue', visible: true, mask: MASK_DECIMAL },
        { title: 'Valor Provisión Mes', property: 'Value', visible: true, mask: MASK_DECIMAL },
        { title: '% Provisión Actual', property: 'TotalProvisionPercent', visible: true },
        { title: 'Meses Provisionados', property: 'ProvisionUnits', visible: true },
        { title: 'Meses a Provisionar', property: 'ProvisionCalculationMonths', visible: true },
        { title: 'Fecha Pago Beneficio', property: 'PaymentDate', visible: true },
        { title: 'Fecha Cálculo Actual', property: 'CalculationDate', visible: true },
        { title: 'Fecha Beneficio Desde', property: 'FromDate', visible: true },
        { title: 'Fecha Beneficio Hasta', property: 'UptoDate', visible: true },
        { title: 'Fecha Actualización', property: 'LastUpdate', visible: true },
        { title: 'Perídos Pendientes de Vacaciones', property: 'VacPendingPeriods', visible: true },
    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [
            { titulo: 'Recalcular provisiones', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModalcalculate({ ...modalcalculate, "view": true }) } },
            // { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const recalculateEmployeeProvisions = () => {

        reprovision.instance.recalculateEmployeeProvisions(data.bean.IDContract, form.Year, form.Month).then(
            (resp: any) => {
                console.log(resp)
                toast.success('Recalculado')
                setModalcalculate({ ...modalcalculate, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })
    }
    return (

        <div className="row">
            <div className="col-md-12">
                <label>Consultar Provisiones</label>
            </div>
            <div className="col-md-6">
                <AccountEditor idAccount={Account} onChange={(e) => { setAccount(e.IDAccount) }} label="Empleado" />
            </div>
            <div className="col-md-6">
                <EmployeeBonusEditor label="Beneficio" idSelector={EmployeeBonus} onChange={(e) => { setEmployeeBonus(e) }} />
            </div>
            <div className="col-md-6">
                <BasicButton icon="ri-align-justify" eventClick={getLista}>Buscar</BasicButton>
            </div>
            {/* <div className="col-md-6 mt-4 p-2">
                <BasicButton icon="ri-align-justify" eventClick={ver}>Generar Provisiones Mensuales</BasicButton>
            </div> */}

            <div className="col-md-12">
                <BasicTable body={lista} head={head} rowSet={data.setBean} listButtons={listaBotones()} pageTop={paginador.page} next={paginador.next} back={paginador.back} records={paginador} customRows={15}></BasicTable>
                {/* <Modal modal={modal} updateModal={setModal} eventModal={createProvisions}>
                    <div className="row">
                        <div className="col-md-12">
                            <AccountantYear idSelector={form.Year} onChange={(e) => { setForm({ ...form, "Year": e }) }} />
                        </div>
                        <div className="col-md-12">
                            <MonthEditorbyconst idSelector={form.Month} onChange={(e) => { setForm({ ...form, "Month": e }) }} />
                        </div>
                    </div>
                </Modal> */}
                <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                    <strong>Eliminar item {data.bean.Name}</strong>
                </ModalConfirm>
                <Modal modal={modalcalculate} updateModal={setModalcalculate} eventModal={recalculateEmployeeProvisions}>

                    <div className="row">
                        <div className="col-md-12">
                            <AccountantYear idSelector={form.Year} onChange={(e) => { setForm({ ...form, "Year": e }) }} />
                        </div>
                        <div className="col-md-12">
                            <MonthEditorbyconst idSelector={form.Month} onChange={(e) => { setForm({ ...form, "Month": e }) }} />
                        </div>
                    </div>

                </Modal>
                <Modal modal={modalviewdoc} updateModal={setModalviewdoc}>
                    <div className="row">
                        <div className="col-md-12">
                            <VisorAnyDocument url={formato} type={type} />
                        </div>
                    </div>
                </Modal>
            </div>

        </div>

    )
}